import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Loading } from './Loading';
export const lazyLoad = (children) => {
    return _jsx(Suspense, { fallback: _jsx(Loading, {}), children: children });
};
